import { gql, useQuery } from '@apollo/client';
import {
  GetCampaignsBlocksQuery,
  GetCampaignsBlocksQueryVariables,
  GetCampaignsQuery,
  GetCampaignsQueryVariables,
} from '__generated__/queries-newsletter';
import { BlockItemType } from 'pages/CampaignPage/CampaignEditPage/ContentPage/Items/utils';

export const GET_CAMPAIGN_COUNT = gql`
  query GetCampaignCount($where: CampaignWhereInput) {
    campaignCount(where: $where)
  }
`;

const GET_CAMPAIGNS = gql`
  query GetCampaigns(
    $first: Int!
    $where: CampaignWhereInput
    $skip: Int
    $orderBy: [CampaignOrderByInput!]
  ) {
    campaigns(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
      id
      _id
      subject
      availableAt
      lockedBy {
        id
        name
        email
        avatarUrl
      }
      newsletter {
        id
        name
        automationTime
        brandKey
      }
      sections(first: 1000) {
        id
        blocks(first: 1000) {
          id
        }
      }
    }
  }
`;

const GET_CAMPAIGNS_BLOCKS = gql`
  query GetCampaignsBlocks(
    $first: Int!
    $where: BlockWhereInput
    $skip: Int
    $orderBy: [BlockOrderByInput!]
  ) {
    blocks(where: $where, orderBy: $orderBy, first: $first, skip: $skip) {
      url
      blockType
      section {
        campaign {
          availableAt
          id
          newsletter {
            id
            name
            automationTime
            brandKey
          }
          subject
        }
      }
    }
  }
`;

export const useGetCampaigns = (variables: GetCampaignsQueryVariables) =>
  useQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GET_CAMPAIGNS, {
    variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });

export const useGetCampaignsBlocks = (blockItems: BlockItemType[]) => {
  const urlList = blockItems.map(
    (blockItem: BlockItemType) => blockItem.url || '',
  );
  return useQuery<GetCampaignsBlocksQuery, GetCampaignsBlocksQueryVariables>(
    GET_CAMPAIGNS_BLOCKS,
    {
      variables: {
        first: 200,
        where: { url_in: urlList },
      },
      skip: !urlList.length,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
    },
  );
};
